import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
type FaqItem = {
  question: string;
  answer: string;
};
const FAQS: FaqItem[] = [{
  question: '¿Necesito saber de tecnología para entender este contenido?',
  answer: 'No. Esta guía fue creada exactamente para personas que no tienen conocimientos técnicos. Todo está explicado con lenguaje simple, pasos claros y ejemplos del día a día.'
}, {
  question: '¿Sirve para cualquier modelo de iPhone?',
  answer: 'Sí. El contenido aplica para la gran mayoría de modelos de iPhone con iOS actual. Ya tengas un iPhone más reciente o uno de hace algunos años, vas a encontrar información útil y aplicable.'
}, {
  question: '¿También sirve si vengo de Android?',
  answer: 'Sí, especialmente para ti. Si cambiaste de Android y todavía no entiendes bien cómo funciona iOS, esta guía te va a ayudar a entender la lógica del iPhone desde el principio.'
}, {
  question: '¿El contenido es difícil de aplicar?',
  answer: 'No. Cada sección está diseñada para que puedas aplicar lo que aprendes de forma inmediata. No necesitas ser experto, no necesitas herramientas externas y no necesitas mucho tiempo.'
}, {
  question: '¿Recibo acceso inmediato después de comprar?',
  answer: 'Sí. Una vez que completas tu compra, recibes acceso inmediato al contenido por mail para que puedas empezar hoy mismo.'
}, {
  question: '¿Puedo verlo desde mi iPhone?',
  answer: 'Sí. Puedes acceder al contenido desde tu iPhone, iPad, computadora o cualquier dispositivo con acceso a internet.'
}, {
  question: '¿Incluye trucos de cámara, seguridad y organización?',
  answer: 'Sí. El libro principal cubre todo eso, y además recibes 5 bonos adicionales que profundizan en configuración, seguridad, organización, trucos ocultos y cámara.'
}, {
  question: '¿Qué pasa si no me gusta?',
  answer: 'Tienes una garantía de satisfacción de 10 días. Si el contenido no cumple tus expectativas, puedes solicitar tu devolución dentro de los 10 días desde tu compra.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-cream-100" data-id="element-123" data-mp="2fwtut002xoy0">
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-deep" data-id="element-124" data-mp="2fxlou6e13em6">
        Preguntas frecuentes
      </p>
      <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-ink-950 sm:text-4xl" data-id="element-125" data-mp="2avnzcuf1bnks">
        Antes de que decidas
      </h2>

      <div className="mt-10 space-y-3" data-id="element-126" data-mp="33lwgcixu41xs">
        {FAQS.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={faq.question} className="overflow-hidden rounded-2xl border border-ink-950/10 bg-white" data-id="element-127" data-mp="2ym0cqkt1ucir" data-mpi={index}>
              <h3 data-id="element-128" data-mp="2ulgibozv1n0b">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-sm font-semibold text-ink-950 transition-colors hover:bg-cream-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent sm:px-7 sm:text-base" data-id="element-129" data-mp="2uo2oplb0lwgy">
                  {faq.question}
                  <motion.span animate={{
                rotate: isOpen ? 45 : 0
              }} transition={{
                duration: 0.2
              }} className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent/10" data-id="element-130" data-mp="2qdnsbs8hts9">
                    <PlusIcon className="h-4 w-4 text-accent-deep" aria-hidden="true" data-id="element-131" data-mp="hfjo632t5q1q" />
                  </motion.span>
                </button>
              </h3>

              <AnimatePresence initial={false} data-id="element-132" data-mp="mfxvfiwl4vyp">
                {isOpen ? <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.28,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-133" data-mp="qgzw8465hg2s">
                    <p className="px-5 pb-6 text-sm leading-relaxed text-ink-800/80 sm:px-7 sm:text-base" data-id="element-134" data-mp="21vprf7gf1agg">
                      {faq.answer}
                    </p>
                  </motion.div> : null}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}